import { path } from "static-path"

export const rootPath = path("/dashboard")
export const joinOrganizationSignupPath = path(
  "/dashboard/:memberInviteToken/sign-up",
)
export const joinOrganizationSigninPath = path(
  "/dashboard/:memberInviteToken/sign-in",
)
export const editProfilePath = path("/dashboard/edit-profile")
export const updatePasswordPath = path("/dashboard/update-password")
export const verifyEmailPath = path("/dashboard/verify-email")
export const createAccountPath = path("/dashboard/create-account")
export const signInPath = path("/dashboard/sign-in")
export const organizationOnboardingPath = path("/dashboard/onboarding")
export const forgotPasswordPath = path("/dashboard/forgot-password")
export const addBeneficiaryPath = path("/dashboard/beneficiaries/new")
export const editBeneficiaryPath = path("/dashboard/beneficiaries/:id/edit")
export const addDeductionPath = path("/dashboard/deductions/new")
export const editDeductionPath = path("/dashboard/deductions/:id/edit")
